import { render, staticRenderFns } from "./NegativeBalanceAdmin.vue?vue&type=template&id=ed9decc8&scoped=true"
import script from "./NegativeBalanceAdmin.vue?vue&type=script&lang=js"
export * from "./NegativeBalanceAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9decc8",
  null
  
)

export default component.exports